<template>
    <div class="text-center">
        <div v-for="(item, i) in items" :key="i" :class="['border-stepper', {'active-border': isActive(i)}]">
            <div :class="['d-none', {'active-text': isActive(i)}]">
                {{ item }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ToolbarStepper",
    props: {
        step: {
            type: [Number, String],
            default: 0
        },
        items: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        isActive(index) {
            return this.step === index
        }
    }
}
</script>

<style scoped>

.border-stepper {
    display: inline-block;
    border: 4px solid #c6c6c6;
    min-width: 36px;
    margin-right: 4px;
    position: relative;
}

.active-border {
    border: 8px solid #CCFF99;
    min-width: 90px;
}

.active-text {
    font-weight: 300;
    font-size: 13px;
    line-height: 16px;
    color: #606060;
    display: block !important;
    position: absolute;
    top: 12px;
    left: 0;
    right: 0;
}

</style>